var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _g, _path33, _path34, _path35, _path36, _g2, _path37, _path38, _path39, _path40, _g3, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _g4, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCharacter(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 296,
    height: 384,
    viewBox: "0 0 296 384",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_189)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M222.806 227.801H94.7528C91.6757 227.801 89.1812 230.294 89.1812 233.369V243.695C89.1812 246.77 91.6757 249.263 94.7528 249.263H222.806C225.883 249.263 228.377 246.77 228.377 243.695V233.369C228.377 230.294 225.883 227.801 222.806 227.801Z",
    fill: "white",
    stroke: "#263238",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M103.498 230.03H94.7529V247.665H103.498V230.03Z",
    fill: "#C6FF00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M114.403 230.03H105.658V247.665H114.403V230.03Z",
    fill: "#11D99A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M125.307 230.03H116.562V247.665H125.307V230.03Z",
    fill: "#11D99A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M136.212 230.03H127.467V247.665H136.212V230.03Z",
    fill: "#11D99A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M147.117 230.03H138.372V247.665H147.117V230.03Z",
    fill: "#11D99A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.022 230.03H149.276V247.665H158.022V230.03Z",
    fill: "#11D99A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.926 230.03H160.181V247.665H168.926V230.03Z",
    fill: "#11D99A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M179.831 230.03H171.086V247.665H179.831V230.03Z",
    fill: "#11D99A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M177.923 81.951L189.388 76.7285L186.966 62.9687L174.32 61.9909C172.697 57.7223 170.561 53.704 167.984 50.0077L174.51 39.0022L164.632 29.1294L153.536 35.7113C147.273 31.4665 140.078 28.4736 132.347 27.0666L129.138 14.3918H115.155L111.934 27.1382C107.543 27.9728 103.332 29.3202 99.3705 31.1326L89.3726 22.488L77.919 30.5007L82.6436 42.8535C79.5774 45.9894 76.881 49.483 74.6142 53.2628L61.4546 51.9035L56.6703 65.0314L67.5631 72.4122C67.0501 75.4288 66.7757 78.529 66.7757 81.6887C66.7757 83.0123 66.8353 84.3119 66.9308 85.6116L55.4653 92.0027L59.0804 105.5L72.061 105.333C73.9819 109.399 76.38 113.203 79.1837 116.661L73.5882 128.286L84.2901 137.265L94.6698 129.836C98.5592 132.078 102.759 133.855 107.173 135.107L109.249 147.614L123.172 148.831L127.372 136.99C132.025 136.573 136.523 135.583 140.77 134.093L149.551 143.012L161.661 136.025L158.332 123.994C161.84 121.013 164.954 117.615 167.626 113.859L179.927 116.124L185.833 103.461L176.181 95.4963C177.29 91.1441 177.887 86.6013 177.911 81.9034L177.923 81.951ZM157.247 81.7126C157.247 100.969 141.617 116.589 122.349 116.589C103.081 116.589 87.4517 100.969 87.4517 81.7126C87.4517 62.4559 103.081 46.836 122.349 46.836C141.617 46.836 157.247 62.4559 157.247 81.7126Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0571 95.2101C43.7014 99.3237 44.6678 103.342 45.9086 107.229",
    stroke: "#263238",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M183.959 30.0237C169.165 12.8299 147.237 1.9436 122.755 1.9436C78.1932 1.9436 42.0669 38.0364 42.0669 82.583C42.0669 83.3223 42.0669 84.0496 42.0908 84.777",
    stroke: "#263238",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M189.376 22.7026L191.511 40.3496L175.154 33.3743L189.376 22.7026Z",
    fill: "#263238"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.784 144.753L282.579 141.843L280.049 127.535L269.777 128.155C268.429 124.602 266.651 121.263 264.516 118.187L270.97 110.055L260.686 99.7768L252.478 106.287C247.264 102.746 241.286 100.266 234.844 99.0971L233.627 88.5566H219.095L217.866 99.1687C214.204 99.8602 210.708 100.993 207.415 102.483L200.292 94.4588L188.385 102.793L193.504 112.237C190.951 114.848 188.708 117.746 186.823 120.893L176.371 118.401L171.396 132.054L180.953 136.835C180.535 139.351 180.296 141.915 180.296 144.55C180.296 145.647 180.344 146.732 180.428 147.817L170.513 151.74L174.271 165.774L184.687 164.236C186.286 167.622 188.278 170.782 190.617 173.655L184.842 182.395L195.973 191.732L203.49 184.613C206.735 186.473 210.219 187.964 213.893 189.001L214.18 199.279L228.664 200.543L230.704 190.563C234.581 190.217 238.316 189.395 241.859 188.155L247.908 196.31L260.495 189.049L256.474 179.76C259.385 177.28 261.986 174.454 264.217 171.33L273.834 174.538L279.978 161.374L271.34 156.068C272.271 152.455 272.76 148.664 272.784 144.765V144.753ZM255.58 144.55C255.58 160.575 242.575 173.572 226.54 173.572C210.505 173.572 197.501 160.575 197.501 144.55C197.501 128.525 210.505 115.528 226.54 115.528C242.575 115.528 255.58 128.525 255.58 144.55Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M286.695 116.863C294.569 133.223 295.822 152.706 288.556 170.901C274.8 205.325 235.715 222.089 201.259 208.341C194.613 205.682 188.612 202.093 183.375 197.765",
    stroke: "#263238",
    strokeWidth: 3.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M280.133 123.684L280.073 105.917L295.5 114.753L280.133 123.684Z",
    fill: "#263238"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1462 384C96.1925 384 123.792 377.06 123.792 368.499C123.792 359.939 96.1925 352.999 62.1462 352.999C28.1 352.999 0.5 359.939 0.5 368.499C0.5 377.06 28.1 384 62.1462 384Z",
    fill: "#263238"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M192.013 355.598C192.072 354.906 192.108 354.203 192.108 353.499C192.108 336.818 176.407 323.309 157.044 323.309C137.68 323.309 121.979 336.83 121.979 353.499C121.979 354.203 122.015 354.906 122.074 355.598H192.013Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M192.013 358.472C192.072 357.78 192.108 357.076 192.108 356.373C192.108 339.692 176.407 326.182 157.044 326.182C137.68 326.182 121.979 339.704 121.979 356.373C121.979 357.076 122.015 357.78 122.074 358.472H192.013Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.7128 163.664L105.825 201.76L132.323 186.903L133.934 199.816C133.934 199.816 108.402 219.836 104.847 221.457C101.291 223.067 94.8247 222.101 93.214 220.17C91.6034 218.226 78.0262 170.114 78.0262 170.114C78.0262 170.114 75.6758 161.088 81.7008 163.664H81.7128Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M131.034 184.983L112.613 196.609L122.408 215.662L137.811 198.862L136.2 181.096L131.034 184.983Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0237 252.828L100.003 298.007C100.003 298.007 88.6923 308.667 80.6151 317.705C72.538 326.743 59.2829 338.368 59.2829 338.368L63.8047 343.853C63.8047 343.853 116.157 304.458 118.734 301.87C121.323 299.283 121.323 294.12 120.679 287.335C120.034 280.551 100.969 227.264 100.969 227.264L55.0117 252.805L55.0237 252.828Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0761 311.54L89.957 330.558L67.8612 342.112C67.8612 342.112 66.5011 346.19 67.8612 349.922C69.2213 353.654 72.6216 357.399 72.9557 359.437C73.2897 361.476 73.6357 362.49 69.2213 362.49C64.8069 362.49 60.0466 358.758 57.6604 356.039C55.2862 353.321 54.9402 345.845 52.9 342.792C50.8599 339.74 47.4596 335.316 50.1798 331.238C52.9 327.16 58.3405 326.481 58.3405 326.481L79.0761 311.54Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M72.1802 362.156C67.3601 360.785 62.9696 356.969 59.9511 352.808C56.5628 348.158 57.4099 340.109 54.0215 337.152C51.9456 335.328 51.7786 331.763 51.9575 329.271C51.3013 329.819 50.6929 330.463 50.1798 331.238C47.4596 335.316 50.8599 339.728 52.9 342.792C54.9402 345.845 55.2743 353.321 57.6604 356.039C60.0346 358.758 64.795 362.49 69.2213 362.49C70.6649 362.49 71.5955 362.383 72.1802 362.168V362.156Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3252 247.522C51.3252 247.522 60.0585 263.572 66.8352 272.932C75.8787 285.416 92.2596 304.47 92.2596 304.47L89.6707 364.863L97.7478 365.828C97.7478 365.828 112.291 306.413 112.614 301.56C112.936 296.719 91.6154 251.183 91.6154 251.183",
    fill: "#263238"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M51.3252 247.522C51.3252 247.522 60.0585 263.572 66.8352 272.932C75.8787 285.416 92.2596 304.47 92.2596 304.47L89.6707 364.863L97.7478 365.828C97.7478 365.828 112.291 306.413 112.614 301.56C112.936 296.719 91.6154 251.183 91.6154 251.183",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M112.47 304.231C112.387 286.012 104.501 272.025 96.3042 256.298L100.074 247.677",
    stroke: "white",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2705 327.876C96.9961 330.129 96.8291 331.691 96.8291 331.691",
    stroke: "white",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7158 257.956C73.0868 267.983 88.5849 292.105 91.9852 295.074C96.2922 298.842 103.844 299.378 102.222 302.073C100.611 304.768 95.2184 307.999 97.3779 308.536C99.5373 309.072 101.685 309.609 100.074 312.84C99.2629 314.462 98.4516 319.171 97.8551 323.476",
    stroke: "white",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9717 253.615C63.9717 253.615 64.5086 254.474 65.4511 255.952",
    stroke: "white",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5131 333.062L109.702 334.851L103.963 364.636C103.963 364.636 106.123 370.014 112.22 371.814C118.316 373.615 120.834 374.688 120.834 377.549C120.834 380.411 118.316 381.138 108.27 382.211C98.2128 383.285 87.8092 379.338 87.8092 379.338C87.8092 379.338 83.1442 378.622 82.7863 375.391C82.4284 372.16 87.4512 363.193 87.4512 363.193L88.525 333.05L88.5131 333.062Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M108.271 382.223C117.827 381.198 120.571 380.494 120.81 377.967C115.787 379.04 109.368 379.862 103.152 379.064C93.2974 377.788 86.0674 374.616 83.0727 373.102C82.8341 374.008 82.7148 374.807 82.7745 375.403C83.1324 378.634 87.7973 379.35 87.7973 379.35C87.7973 379.35 98.2129 383.296 108.259 382.223H108.271Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0625 171.509C51.0625 171.509 26.5448 184.005 20.9016 190.134C15.2583 196.263 19.6727 201.891 21.8799 208.27C24.0871 214.637 52.8163 251.111 55.0235 252.828C57.2307 254.545 68.5053 249.156 83.717 242.538C98.9168 235.921 102.591 233.226 102.591 229.553C102.591 225.881 82.9296 166.37 81.7127 163.675C80.4838 160.981 57.4336 167.837 51.0625 171.521V171.509Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_20_189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 163,
    width: 85,
    height: 91
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0625 171.509C51.0625 171.509 26.5448 184.005 20.9016 190.134C15.2583 196.263 19.6727 201.891 21.8799 208.27C24.0871 214.637 52.8163 251.111 55.0235 252.828C57.2307 254.545 68.5053 249.156 83.717 242.538C98.9168 235.921 102.591 233.226 102.591 229.553C102.591 225.881 82.9296 166.37 81.7127 163.675C80.4838 160.981 57.4336 167.837 51.0625 171.521V171.509Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_20_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.3214 220.193L60.762 220.849L38.7378 216.58C38.7378 216.58 23.2875 209.677 23.2875 201.473C23.2875 193.27 32.8202 190.301 32.8202 190.301L56.1567 184.053L57.8032 169.601C57.4214 169.601 56.3715 169.637 54.8921 169.697C53.3411 170.341 52.0168 170.961 51.0742 171.509C51.0742 171.509 26.5565 184.005 20.9133 190.134C15.27 196.263 19.6844 201.891 21.8916 208.27C24.0988 214.637 52.8281 251.111 55.0353 252.828C57.2424 254.545 68.517 249.156 83.7287 242.538C83.8958 242.467 84.0389 242.395 84.206 242.324C79.8393 243.206 65.8326 246.64 61.4301 242.872C56.8249 238.925 47.2922 229.076 47.2922 229.076L82.7981 229.41L44.3334 220.217L44.3214 220.193Z",
    fill: "#C6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.3214 220.193L60.762 220.849L38.7378 216.58C38.7378 216.58 23.2875 209.677 23.2875 201.473C23.2875 193.27 32.8202 190.301 32.8202 190.301L56.1567 184.053L57.8032 169.601C57.4214 169.601 56.3715 169.637 54.8921 169.697C53.3411 170.341 52.0168 170.961 51.0742 171.509C51.0742 171.509 26.5565 184.005 20.9133 190.134C15.27 196.263 19.6844 201.891 21.8916 208.27C24.0988 214.637 52.8281 251.111 55.0353 252.828C57.2424 254.545 68.517 249.156 83.7287 242.538C83.8958 242.467 84.0389 242.395 84.206 242.324C79.8393 243.206 65.8326 246.64 61.4301 242.872C56.8249 238.925 47.2922 229.076 47.2922 229.076L82.7981 229.41L44.3334 220.217L44.3214 220.193Z",
    fill: "#11D99A"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0625 171.509C51.0625 171.509 26.5448 184.005 20.9016 190.134C15.2583 196.263 19.6727 201.891 21.8799 208.27C24.0871 214.637 52.8163 251.111 55.0235 252.828C57.2307 254.545 68.5053 249.156 83.717 242.538C98.9168 235.921 102.591 233.226 102.591 229.553C102.591 225.881 82.9296 166.37 81.7127 163.675C80.4838 160.981 57.4336 167.837 51.0625 171.521V171.509Z",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2021 175.134C45.7174 177.399 49.5471 182.503 55.4767 186.211C63.3272 191.112 68.4693 190.134 71.1657 185.233C73.3729 181.227 69.8414 169.351 68.4812 165.154C61.7284 166.99 54.2717 169.649 51.0623 171.509C51.0623 171.509 48.199 172.964 44.2021 175.134Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5012 162.197C66.5012 162.197 64.5446 164.403 65.0337 166.847C65.5229 169.303 67.9806 178.854 67.7301 182.038C67.4795 185.221 64.5446 185.71 58.4122 183.266C52.2797 180.81 48.3545 173.703 47.3762 171.998C46.3979 170.281 42.4727 159.991 42.4727 159.991L45.169 158.274C45.169 158.274 47.8654 162.435 54.4869 162.435C61.1085 162.435 65.7615 159.001 66.5012 160.48C67.2409 161.947 66.5012 162.197 66.5012 162.197Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_20_189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 158,
    width: 26,
    height: 27
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5012 162.197C66.5012 162.197 64.5446 164.403 65.0337 166.847C65.5229 169.303 67.9806 178.854 67.7301 182.038C67.4795 185.221 64.5446 185.71 58.4122 183.266C52.2797 180.81 48.3545 173.703 47.3762 171.998C46.3979 170.281 42.4727 159.991 42.4727 159.991L45.169 158.274C45.169 158.274 47.8654 162.435 54.4869 162.435C61.1085 162.435 65.7615 159.001 66.5012 160.48C67.2409 161.947 66.5012 162.197 66.5012 162.197Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_20_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.2147 172.916L66.5012 162.209L66.1433 160.194C64.7832 159.705 60.4285 162.447 54.4869 162.447C47.8654 162.447 45.169 158.286 45.169 158.286L42.4727 160.003C42.4727 160.003 46.3979 170.293 47.3762 172.01C48.3545 173.727 52.2797 180.834 58.4122 183.278C59.0326 183.528 59.6172 183.731 60.166 183.922L55.2028 172.916H55.2147Z",
    fill: "#C6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2147 172.916L66.5012 162.209L66.1433 160.194C64.7832 159.705 60.4285 162.447 54.4869 162.447C47.8654 162.447 45.169 158.286 45.169 158.286L42.4727 160.003C42.4727 160.003 46.3979 170.293 47.3762 172.01C48.3545 173.727 52.2797 180.834 58.4122 183.278C59.0326 183.528 59.6172 183.731 60.166 183.922L55.2028 172.916H55.2147Z",
    fill: "#11D99A"
  }))), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M66.5012 162.197C66.5012 162.197 64.5446 164.403 65.0337 166.847C65.5229 169.303 67.9806 178.854 67.7301 182.038C67.4795 185.221 64.5446 185.71 58.4122 183.266C52.2797 180.81 48.3545 173.703 47.3762 171.998C46.3979 170.281 42.4727 159.991 42.4727 159.991L45.169 158.274C45.169 158.274 47.8654 162.435 54.4869 162.435C61.1085 162.435 65.7615 159.001 66.5012 160.48C67.2409 161.947 66.5012 162.197 66.5012 162.197Z",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4268 151.907L37.5689 158.524L44.1905 155.83L39.2869 146.756L32.4268 151.907Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2557 154.602C41.2557 154.602 33.8944 144.8 34.1449 141.855C34.3955 138.91 49.7265 127.785 53.8903 128.513C58.0542 129.252 64.628 141.724 64.628 141.724L68.3146 145.408L67.0858 148.842C67.0858 148.842 73.3733 157.535 72.6455 158.763C71.9058 159.991 66.2745 163.413 59.4023 164.892C52.5302 166.37 45.9206 161.947 45.9206 161.947C45.9206 161.947 41.2676 163.902 39.299 162.686C37.3304 161.47 34.646 157.046 35.1352 156.068C35.6243 155.09 41.2676 154.602 41.2676 154.602H41.2557Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_20_189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 128,
    width: 39,
    height: 38
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2557 154.602C41.2557 154.602 33.8944 144.8 34.1449 141.855C34.3955 138.91 49.7265 127.785 53.8903 128.513C58.0542 129.252 64.628 141.724 64.628 141.724L68.3146 145.408L67.0858 148.842C67.0858 148.842 73.3733 157.535 72.6455 158.763C71.9058 159.991 66.2745 163.413 59.4023 164.892C52.5302 166.37 45.9206 161.947 45.9206 161.947C45.9206 161.947 41.2676 163.902 39.299 162.686C37.3304 161.47 34.646 157.046 35.1352 156.068C35.6243 155.09 41.2676 154.602 41.2676 154.602H41.2557Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_20_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3906 164.892C62.3017 164.272 64.998 163.294 67.1813 162.28C66.9427 162.268 66.7041 162.245 66.5013 162.197C63.5902 161.624 55.2148 159.729 51.9696 155.675C48.7244 151.621 47.1019 150.404 47.1019 150.404L65.2605 142.38L64.6162 141.736C64.6162 141.736 58.0543 129.264 53.8785 128.525C49.7147 127.785 34.3717 138.922 34.1331 141.867C33.8945 144.812 41.2439 154.613 41.2439 154.613C41.2439 154.613 35.6006 155.102 35.1115 156.08C34.6223 157.058 37.3186 161.469 39.2753 162.698C41.2319 163.926 45.8969 161.958 45.8969 161.958C45.8969 161.958 52.5184 166.37 59.3786 164.903L59.3906 164.892Z",
    fill: "#C6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3906 164.892C62.3017 164.272 64.998 163.294 67.1813 162.28C66.9427 162.268 66.7041 162.245 66.5013 162.197C63.5902 161.624 55.2148 159.729 51.9696 155.675C48.7244 151.621 47.1019 150.404 47.1019 150.404L65.2605 142.38L64.6162 141.736C64.6162 141.736 58.0543 129.264 53.8785 128.525C49.7147 127.785 34.3717 138.922 34.1331 141.867C33.8945 144.812 41.2439 154.613 41.2439 154.613C41.2439 154.613 35.6006 155.102 35.1115 156.08C34.6223 157.058 37.3186 161.469 39.2753 162.698C41.2319 163.926 45.8969 161.958 45.8969 161.958C45.8969 161.958 52.5184 166.37 59.3786 164.903L59.3906 164.892Z",
    fill: "#11D99A"
  }))), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2557 154.602C41.2557 154.602 33.8944 144.8 34.1449 141.855C34.3955 138.91 49.7265 127.785 53.8903 128.513C58.0542 129.252 64.628 141.724 64.628 141.724L68.3146 145.408L67.0858 148.842C67.0858 148.842 73.3733 157.535 72.6455 158.763C71.9058 159.991 66.2745 163.413 59.4023 164.892C52.5302 166.37 45.9206 161.947 45.9206 161.947C45.9206 161.947 41.2676 163.902 39.299 162.686C37.3304 161.47 34.646 157.046 35.1352 156.068C35.6243 155.09 41.2676 154.602 41.2676 154.602H41.2557Z",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M125.594 156.557L152.808 335.197L156.244 334.708L130.009 156.307C130.009 156.307 128.291 155.567 125.594 156.557Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M126.334 178.616C126.334 178.616 120.941 177.388 120.941 180.571C120.941 183.755 120.452 189.144 122.409 190.372C124.365 191.601 126.823 191.112 127.062 188.167C127.312 185.221 127.062 177.876 126.322 178.604L126.334 178.616Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M129.496 191.958C129.496 191.958 129.317 195.81 130.044 196.191C130.772 196.573 140.687 195.81 141.045 195.034C141.414 194.259 141.223 191.183 140.496 190.992C139.768 190.802 130.402 190.992 129.496 191.958Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M126.584 186.95C126.584 186.95 126.345 191.851 127.288 192.34C128.219 192.829 140.841 191.851 141.307 190.873C141.772 189.895 141.545 185.973 140.603 185.722C139.66 185.472 127.753 185.722 126.584 186.95Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M126.095 181.561C126.095 181.561 125.845 186.461 126.835 186.95C127.813 187.439 141.056 186.461 141.546 185.484C142.035 184.506 141.796 180.583 140.806 180.333C139.827 180.082 127.324 180.333 126.095 181.561Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M125.355 176.171C125.355 176.171 125.105 181.072 126.095 181.561C127.073 182.05 140.317 181.072 140.806 180.094C141.295 179.116 141.056 175.194 140.066 174.943C139.076 174.693 126.584 174.943 125.355 176.171Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5752 198.862C18.9093 206.267 25.3161 211.513 29.289 214.077C31.1025 215.245 33.2262 215.853 35.3856 215.817L106.72 214.875V199.196L29.7305 188.417C29.7305 188.417 23.61 188.655 21.9635 193.258",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_20_189",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 188,
    width: 89,
    height: 28
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5752 198.862C18.9093 206.267 25.3161 211.513 29.289 214.077C31.1025 215.245 33.2262 215.853 35.3856 215.817L106.72 214.875V199.196L29.7305 188.417C29.7305 188.417 23.61 188.655 21.9635 193.258",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_20_189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7305 188.417C29.7305 188.417 23.61 188.655 21.9635 193.258L18.5752 198.862C18.9093 206.267 25.3161 211.513 29.289 214.077C31.1025 215.245 33.2262 215.853 35.3856 215.817L106.72 214.875V202.952C105.24 201.271 103.832 199.709 102.866 198.647L101.232 198.421L97.5807 210.988C97.5807 210.988 54.8447 209.999 42.0311 207.697C29.2174 205.396 25.2684 202.773 24.9343 196.859C24.6002 190.945 29.7424 188.405 29.7424 188.405L29.7305 188.417Z",
    fill: "#C6FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.7305 188.417C29.7305 188.417 23.61 188.655 21.9635 193.258L18.5752 198.862C18.9093 206.267 25.3161 211.513 29.289 214.077C31.1025 215.245 33.2262 215.853 35.3856 215.817L106.72 214.875V202.952C105.24 201.271 103.832 199.709 102.866 198.647L101.232 198.421L97.5807 210.988C97.5807 210.988 54.8447 209.999 42.0311 207.697C29.2174 205.396 25.2684 202.773 24.9343 196.859C24.6002 190.945 29.7424 188.405 29.7424 188.405L29.7305 188.417Z",
    fill: "#11D99A"
  }))), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5752 198.862C18.9093 206.267 25.3161 211.513 29.289 214.077C31.1025 215.245 33.2262 215.853 35.3856 215.817L106.72 214.875V199.196L29.7305 188.417C29.7305 188.417 23.61 188.655 21.9635 193.258",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M101.565 197.252L101.076 220.289L124.616 215.388C124.616 215.388 136.63 216.366 139.326 216.127C142.023 215.889 144.23 211.966 144.23 209.999V205.587C144.23 205.587 146.186 204.12 145.948 202.153C145.697 200.198 141.784 198.969 141.784 198.969C141.784 198.969 130.509 196.513 127.312 197.252C124.126 197.992 101.565 197.252 101.565 197.252Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2412 154.852L70.4381 135.989C70.4381 135.989 72.1562 134.761 69.4598 134.522C66.7635 134.272 61.3708 135.262 61.3708 135.262C61.3708 135.262 52.6733 122.909 50.9552 122.408C49.2372 121.919 48.2589 122.408 48.0083 123.386L47.7578 124.363C47.7578 124.363 33.6556 128.393 28.251 135.5C22.8583 142.606 29.2293 154.864 29.2293 154.864L29.2412 154.852Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M48.3185 125.675L50.1439 129.324C50.1439 129.324 45.479 131.553 45.479 133.986C45.479 136.418 49.1298 142.094 49.1298 142.094",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7296 133.378C34.7296 133.378 32.4985 135.81 32.4985 138.85C32.4985 141.891 35.7437 147.769 35.7437 147.769",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6587 151.215L53.389 140.269",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M192.013 360.976C192.072 360.284 192.108 359.58 192.108 358.877C192.108 342.196 176.407 328.686 157.044 328.686C137.68 328.686 121.979 342.208 121.979 358.877C121.979 359.58 122.015 360.284 122.074 360.976H192.013Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M192.013 363.849C192.072 363.157 192.108 362.454 192.108 361.751C192.108 345.069 176.407 331.56 157.044 331.56C137.68 331.56 121.979 345.081 121.979 361.751C121.979 362.454 122.015 363.157 122.074 363.849H192.013Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M157.044 331.56C145.113 331.56 134.578 336.699 128.243 344.545L136.463 351.031C141.068 345.332 148.107 341.683 156.017 341.683C163.928 341.683 170.967 345.332 175.572 351.031L186.262 345.069C179.986 336.926 169.237 331.56 157.044 331.56Z",
    fill: "#11D99A",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M166.612 362.967C166.612 357.088 161.852 352.331 155.97 352.331C150.088 352.331 145.328 357.088 145.328 362.967C145.328 363.265 145.351 363.563 145.375 363.849H166.576C166.6 363.551 166.624 363.265 166.624 362.967H166.612Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.08,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 295,
    height: 384,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacter);
export default __webpack_public_path__ + "static/media/Character.89210993e8c07a4a6d096009500a6da3.svg";
export { ForwardRef as ReactComponent };